//Get Reducer Call--->
export const getCollectionsRequest = (page: number, size: number, search: string, order_id: string) => ({
    type: 'GET_COLLECTIONS_REQUEST',
    payload: { page, size, search, order_id },
});

export const getCollectionsSuccess = (data: any) => ({
    type: 'GET_COLLECTIONS_SUCCESS',
    payload: { data },
});

export const getCollectionsFailure = (data: string) => ({
    type: 'GET_COLLECTIONS_FAILURE',
    payload: { data },
});

export const resetGetCollections = () => ({
    type: 'RESET_GET_COLLECTIONS',
});

export const getCollectionsReportRequest = (
    page: number,
    size: number,
    search: string,
    from_date: string,
    to_date: string
) => ({
    type: 'GET_COLLECTIONS_REPORT_REQUEST',
    payload: { page, size, search, from_date, to_date },
});

export const getCollectionsReportSuccess = (data: any) => ({
    type: 'GET_COLLECTIONS_REPORT_SUCCESS',
    payload: { data },
});

export const getCollectionsReportFailure = (data: string) => ({
    type: 'GET_COLLECTIONS_REPORT_FAILURE',
    payload: { data },
});

export const resetGetCollectionsReport = () => ({
    type: 'RESET_GET_COLLECTIONS_REPORT',
});

export const getCollectionsUserReportRequest = (
    user_id: string,
    collection_date: string,
    route: string,

) => ({
    type: 'GET_COLLECTIONS_USER_REPORT_REQUEST',
    payload: { user_id, collection_date, route },
});

export const getCollectionsUserReportSuccess = (data: any) => ({
    type: 'GET_COLLECTIONS_USER_REPORT_SUCCESS',
    payload: { data },
});

export const getCollectionsUserReportFailure = (data: string) => ({
    type: 'GET_COLLECTIONS_USER_REPORT_FAILURE',
    payload: { data },
});

export const resetGetCollectionsUserReport = () => ({
    type: 'RESET_GET_COLLECTIONS_USER_REPORT',
});

//Create Reducer Call--->
export const createCollectionsRequest = (data: any) => ({
    type: 'CREATE_COLLECTIONS_REQUEST',
    payload: data,
});

export const createCollectionsSuccess = (data: any) => ({
    type: 'CREATE_COLLECTIONS_SUCCESS',
    payload: { data },
});

export const createCollectionsFailure = (data: string) => ({
    type: 'CREATE_COLLECTIONS_FAILURE',
    payload: { data },
});

export const resetCreateCollections = () => ({
    type: 'RESET_CREATE_COLLECTIONS',
});

//Update Reducer Call--->
export const updateCollectionsRequest = (data: any, id: string) => ({
    type: 'UPDATE_COLLECTIONS_REQUEST',
    payload: { data, id },
});

export const updateCollectionsSuccess = (data: any) => ({
    type: 'UPDATE_COLLECTIONS_SUCCESS',
    payload: { data },
});

export const updateCollectionsFailure = (data: string) => ({
    type: 'UPDATE_COLLECTIONS_FAILURE',
    payload: { data },
});

export const resetUpdateCollections = () => ({
    type: 'RESET_UPDATE_COLLECTIONS',
});
//Delete Reducer Call--->
export const deleteCollectionsRequest = (id: string) => ({
    type: 'DELETE_COLLECTIONS_REQUEST',
    payload: { id },
});

export const deleteCollectionsSuccess = (data: any) => ({
    type: 'DELETE_COLLECTIONS_SUCCESS',
    payload: { data },
});

export const deleteCollectionsFailure = (data: string) => ({
    type: 'DELETE_COLLECTIONS_FAILURE',
    payload: { data },
});

export const resetDeleteCollections = () => ({
    type: 'RESET_DELETE_COLLECTIONS',
});
